import api from '@/lib/api/axios'
import type { User, Role, ListParams, PaginatedResponse } from '@/lib/api/types'

export const usersApi = {
    list: (params?: ListParams) =>
        api.get<PaginatedResponse<User>>('/api/users', { params }),

    get: (id: number) =>
        api.get<User>(`/api/users/${id}`),

    create: (data: Omit<User, 'id' | 'createdAt' | 'updatedAt' | 'mfa'> & { password: string; mfaRequired?: boolean; mfaMethods?: string[] }) =>
        api.post<User>('/api/users', data),

    update: (id: number, data: Partial<Omit<User, 'id' | 'createdAt' | 'updatedAt' | 'mfa'> & { mfaRequired?: boolean; mfaMethods?: string[] }>) =>
        api.put<User>(`/api/users/${id}`, data),

    changePassword: (id: number, payload: { newPassword: string; currentPassword?: string }) =>
        api.put<unknown>(`/api/users/${id}/password`, payload),

    delete: (id: number) =>
        api.delete(`/api/users/${id}`),
}

export const rolesApi = {
    list: (params?: ListParams) =>
        api.get<PaginatedResponse<Role>>('/api/roles', { params }),

    get: (id: number) =>
        api.get<Role>(`/api/roles/${id}`),

    create: (data: Omit<Role, 'id'>) =>
        api.post<Role>('/api/roles', data),

    update: (id: number, data: Partial<Omit<Role, 'id'>>) =>
        api.put<Role>(`/api/roles/${id}`, data),

    delete: (id: number) =>
        api.delete(`/api/roles/${id}`),
}



